<template>
  <h2
    :class="{
      'text-xl': !smaller,
      'text-l': smaller,
      uppercase: uppercase,
      underline: underline
    }"
    v-accent="header"
  >
  </h2>
</template>

<script>
export default {
  name: 'accentHeader',
  props: ['header', 'uppercase', 'smaller', 'underline']
}
</script>

<style scoped lang="scss">
</style>
